import { StatusBar, Style } from '@capacitor/status-bar'
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { Device } from '@capacitor/device'
import httpRequest from '@/services/httpRequest'

function hexToRgb(hex) {
  // Remove leading '#' if present
  hex = hex.replace(/^#/, '');

  // Convert 3-digit hex to 6-digit
  if (hex.length === 3) {
    hex = hex.split('').map(char => char + char).join('');
  }

  if (hex.length !== 6) {
    throw new Error('Invalid HEX color.');
  }

  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  return `${r} ${g} ${b}`;
}

export default ({
    namespaced: true,
    state: {
        defaultTheme: {
            primary_color: '#21bb8f',
            secondary_color: '#2F507B',
            background_color: '#F6FBFF'
        },
        school: {}
    },
    mutations: {
        SET_THEME(state, theme) {
            const secondary = hexToRgb(theme.secondary_color);
            const primary = hexToRgb(theme.primary_color);
            const background = hexToRgb(theme.background_color);
            const danger = hexToRgb("#F44336");
            document.documentElement.style.setProperty('--color-primary', theme.primary_color)
            document.documentElement.style.setProperty('--primary-color', theme.primary_color)
            document.documentElement.style.setProperty('--ion-color-primary', theme.primary_color)
            document.documentElement.style.setProperty('--color-rgb-primary', primary)

            document.documentElement.style.setProperty('--color-secondary', theme.secondary_color)
            document.documentElement.style.setProperty('--secondary-color', theme.secondary_color)
            document.documentElement.style.setProperty('--ion-color-secondary', theme.secondary_color)
            document.documentElement.style.setProperty('--color-rgb-secondary', secondary)
            
            document.documentElement.style.setProperty('--color-danger', "#F44336")
            document.documentElement.style.setProperty('--danger-color', "#F44336")
            document.documentElement.style.setProperty('--ion-color-danger', "#F44336")
            document.documentElement.style.setProperty('--color-rgb-danger', danger)
            
            document.documentElement.style.setProperty('--ion-background-color', theme.background_color)
            document.documentElement.style.setProperty('--ion-toolbar-background', theme.background_color)
            document.documentElement.style.setProperty('--color-rgb-background', background)
        },

        SET_SCHOOL(state, data) {
            state.school = data
        }
    },
    actions: {
        async getTheme({ state, rootState, commit }, status) {
            //console.log("DATA SEKOLAH = ", rootState.auth.schoolData)
            let domain = status === 'login' ?  rootState.auth.schoolData?.domain : rootState.baseURL

            if (domain) {
                const payload = {
                    options: {
                        url: `${domain}/api/v1/theme`,
                        method: 'GET'
                    },
                    //authorized: true
                }
    
                const res = await httpRequest(payload)
                //console.log('Fetching theme from API', res)
    
                if (res.status === 200) {
                    //console.log('BERHASIL MENDAPATKAN TEMA')
                    commit('SET_THEME', res.data.results[0])
                    commit('SET_SCHOOL', res.data.results[0])
                } else {
                    //console.log('GAGAL MENDAPATKAN TEMA')
                    commit('SET_THEME', state.defaultTheme)
                }
            } else {
                commit('SET_THEME', state.defaultTheme)
            }

            
            const deviceInfo = await Device.getInfo()

            if (deviceInfo.platform !== 'web') {
                await EdgeToEdge.enable();
                await EdgeToEdge.setBackgroundColor({ color: state.defaultTheme.background_color });
                //await StatusBar.setOverlaysWebView({ overlay: true })
                await StatusBar.setStyle({ style: Style.Light })
                //await StatusBar.setBackgroundColor({ color: state.defaultTheme.backgroundColor })
            }
        }
    },
})